import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ReviewQueuePage = lazy(() => import("@/features/dashboard/pages/review-queue"));

export const Route = createFileRoute("/(app)/dashboard/bulk-docs/review-queue")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading review queue...</div>}>
      <ReviewQueuePage />
    </Suspense>
  ),
});
